/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateCarsWebRequest } from '../models/CreateCarsWebRequest';
import type { CreateVehiclesResponse } from '../models/CreateVehiclesResponse';
import type { GetVehicleSpecificationResponse } from '../models/GetVehicleSpecificationResponse';
import type { VehicleInfo } from '../models/VehicleInfo';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class VehicleService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * @returns CreateVehiclesResponse OK
   * @throws ApiError
   */
  public createCars({
    authorization,
    requestBody,
    diAuthorization,
  }: {
    authorization?: string,
    requestBody: CreateCarsWebRequest,
    diAuthorization?: string,
  }): CancelablePromise<CreateVehiclesResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/cars/',
      headers: {
        'Authorization': authorization,
        'DI-Authorization': diAuthorization,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @returns CreateVehiclesResponse OK
   * @throws ApiError
   */
  public createCars1({
    authorization,
    requestBody,
    diAuthorization,
  }: {
    authorization?: string,
    requestBody: CreateCarsWebRequest,
    diAuthorization?: string,
  }): CancelablePromise<CreateVehiclesResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/cars',
      headers: {
        'Authorization': authorization,
        'DI-Authorization': diAuthorization,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @returns VehicleInfo OK
   * @throws ApiError
   */
  public getVehicle({
    vin,
    puid,
    authorization,
    cciAccessToken,
  }: {
    vin: string,
    puid: string,
    authorization?: string,
    cciAccessToken?: string,
  }): CancelablePromise<VehicleInfo> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/vehicles/{vin}',
      path: {
        'vin': vin,
      },
      headers: {
        'Authorization': authorization,
        'Cci-Access-Token': cciAccessToken,
      },
      query: {
        'puid': puid,
      },
    });
  }
  /**
   * @returns VehicleInfo OK
   * @throws ApiError
   */
  public getVehicle1({
    vin,
    puid,
    authorization,
    cciAccessToken,
  }: {
    vin: string,
    puid: string,
    authorization?: string,
    cciAccessToken?: string,
  }): CancelablePromise<VehicleInfo> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/vehicles/{vin}/',
      path: {
        'vin': vin,
      },
      headers: {
        'Authorization': authorization,
        'Cci-Access-Token': cciAccessToken,
      },
      query: {
        'puid': puid,
      },
    });
  }
  /**
   * @returns GetVehicleSpecificationResponse OK
   * @throws ApiError
   */
  public getVehicleSpecification({
    vin,
    puid,
    authorization,
  }: {
    vin: string,
    puid: string,
    authorization?: string,
  }): CancelablePromise<GetVehicleSpecificationResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/vehicles/specification',
      headers: {
        'Authorization': authorization,
      },
      query: {
        'vin': vin,
        'puid': puid,
      },
    });
  }
  /**
   * @returns VehicleInfo OK
   * @throws ApiError
   */
  public getVehicleWithoutAdjustment({
    vin,
    puid,
  }: {
    vin: string,
    puid: string,
  }): CancelablePromise<VehicleInfo> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/vehicles/info-only/{vin}/',
      path: {
        'vin': vin,
      },
      query: {
        'puid': puid,
      },
    });
  }
  /**
   * @returns VehicleInfo OK
   * @throws ApiError
   */
  public getVehicleWithoutAdjustment1({
    vin,
    puid,
  }: {
    vin: string,
    puid: string,
  }): CancelablePromise<VehicleInfo> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/vehicles/info-only/{vin}',
      path: {
        'vin': vin,
      },
      query: {
        'puid': puid,
      },
    });
  }
}
